import React from 'react';

export const CategoriesListHeader = () => {
    return (
        <li className="list-group-item">
            <div className="row d-flex d-lg-none">
                <div className="col">
                    <h3 className="text-center h4 lg-0">Categories list</h3>
                </div>
            </div>
            <div className="row d-none d-lg-flex">
                <div className="icon-header col-lg-1 col-xl-1" />
                <div className="name-header col-lg-8 col-xl-9">
                    <p className="my-1">
                        <strong>Name</strong>
                    </p>
                </div>
                <div className="actions-header col-lg-3 col-xl-2">
                    <p className="text-center my-1">
                        <strong>Actions</strong>
                    </p>
                </div>
            </div>
        </li>
    );
};
